export default __webpack_public_path__ + "static/media/KAYO_icon.e4544f32.png";